import type { I18nT } from "@lib/dashboardI18n";

import { allAspectRatios } from "../constants";
import type { AspectRatio, AspectRatioOption } from "../types";
import { getAspectRatioInfo } from "./getAspectRatioInfo";
import { getCustomAspectRatioOptions } from "./getCustomAspectRatioOptions";

/**
 * Retrieve all aspect ratio options
 */
export const getAllAspectRatioOptions = (t: I18nT<"media-library">, tolerance?: number): AspectRatioOption[] => {
  return getCustomAspectRatioOptions(
    Object.values(allAspectRatios).map((aspectRatio: AspectRatio) => {
      return getAspectRatioInfo(t, aspectRatio, tolerance);
    })
  );
};
